import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./app/plugins/store";
import vuetify from "@/app/plugins/vuetify/vuetify";
import { sync } from "vuex-router-sync";

// plugins
import "@/app/plugins";
import i18n from "@/app/plugins/i18n";
import VueSocialSharing from "vue-social-sharing";

Vue.use(VueSocialSharing);

/* eslint-disable-next-line no-console */
console.clear();

sync(store, router);

Vue.config.productionTip = false;

if (window.location.hostname === "termbank.valeontis.com") {
  new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App),
    created() {
      this.$router.push({ path: "/app/termbank/termmaster" });
    }
  }).$mount("#app");
} else {
  new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
}
